import PropTypes from 'prop-types'
import { ForbiddenPage } from 'components/elements'
import List from 'containers/pages/categories/List'
import Form from 'containers/pages/categories/Form'

const Category = ({ location, match, currentUser }) => {
  if (location.pathname === '/category') {
    if (currentUser.role === "Super Admin") {
      return <List location={location} />
    }
    return <ForbiddenPage />
  }

  if (location.pathname.includes('/add') || location.pathname.includes('/edit')) {
    if (currentUser.role === "Super Admin") {
      return <Form match={match} location={location} />
    }
    return <ForbiddenPage />
  }

  return ''
}

Category.propTypes = {
  currentUser: PropTypes.object,
  location: PropTypes.object,
  match: PropTypes.object,
}

export default Category